import { useEffect, useState } from "react";
import { useLanding } from "@/context/LandingContext";

const pad = (n) => String(n).padStart(2, "0");

export function Countdown() {
  const { t, selectedEvent } = useLanding();
  const [parts, setParts] = useState(["00", "00", "00", "00"]);

  useEffect(() => {
    const target = new Date(selectedEvent.iso).getTime();
    const tick = () => {
      const distance = Math.max(0, target - Date.now());
      setParts([
        pad(Math.floor(distance / 86400000)),
        pad(Math.floor((distance % 86400000) / 3600000)),
        pad(Math.floor((distance % 3600000) / 60000)),
        pad(Math.floor((distance % 60000) / 1000)),
      ]);
    };
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [selectedEvent]);

  return (
    <div className="countdown" aria-label="Time until webinar" data-testid="countdown">
      {parts.map((value, index) => (
        <div className="count-box" key={t.register.countdown[index]}>
          <strong>{value}</strong>
          <small>{t.register.countdown[index]}</small>
        </div>
      ))}
    </div>
  );
}
